import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import AdminButton from "../components/common/AdminButton.jsx";
import LayoutNoVideo from "../components/common/LayoutNoVideo.jsx";
import { posts as staticPosts } from "../static/posts.js";
import { Helmet } from "react-helmet-async";

const slugify = (text) => {
  return text
    .toString()
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-')
    .replace(/[^\w\-]+/g, '')
    .replace(/\-\-+/g, '-');
};

const Blog = () => {
    const isAdmin = localStorage.getItem("isAdmin") === "true";
    
    const [posts, setPosts] = useState([]);

    useEffect(() => {
        const now = new Date().toISOString();
        const filteredPosts = staticPosts.filter(post => {
            return new Date(post.date).toISOString() <= now;
        });
        
        setPosts(filteredPosts);
    }, []);

    const handleDelete = (id) => {
        const confirm = window.confirm("Are you sure you want to delete this post?");
        if (!confirm) return;
        setPosts((prev) => prev.filter((post) => post.id !== id));
    };

    return (
        <>
            <Helmet>
                <title>Blog - Slowork</title>
                <meta name="description" content="Artículos sobre trabajo remoto, nómadas digitales y consejos para profesionales" />
                <meta property="og:title" content="Blog - Slowork" />
                <meta property="og:description" content="Artículos sobre trabajo remoto, nómadas digitales y consejos para profesionales" />
            </Helmet>
            <LayoutNoVideo>
                <div className="min-h-screen bg-[#e6f2ea] dark:bg-[#0a1a1a] text-gray-800 dark:text-gray-100">
                    <section className="max-w-7xl mx-auto px-6 py-24">
                        <h1 className="text-4xl font-bold mb-10 text-primary dark:text-lightGreen text-center">
                            Slowork Blog
                        </h1>

                        {posts.length === 0 ? (
                            <p className="text-center text-lg">No hay publicaciones disponibles actualmente.</p>
                        ) : (
                            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                                {posts.map((post) => (
                                    <div
                                        key={post.id}
                                        className="bg-white dark:bg-[#1a2a2a] rounded-xl shadow-lg overflow-hidden flex flex-col transition hover:scale-[1.02]"
                                    >
                                        {post.image && (
                                            <img
                                                src={post.image}
                                                alt={post.title}
                                                className="w-full h-48 object-cover"
                                            />
                                        )}

                                        <div className="p-4 flex flex-col flex-1">
                                            <h2 className="text-xl font-semibold text-secondary dark:text-lightGreen mb-2">
                                                <Link
                                                    to={`/blog/${slugify(post.title)}`}
                                                >
                                                    {post.title}
                                                </Link>
                                            </h2>
                                            <p className="text-sm text-gray-500 mb-2">
                                                {new Date(post.date).toLocaleDateString()}
                                            </p>
                                            <p className="text-base flex-1 mb-3">
                                                {post.excerpt || post.content.slice(0, 100).replace(/#|!\[.*?\]|\*/g, '') + "..."}
                                            </p>

                                            <Link
                                                to={`/blog/${slugify(post.title)}`}
                                                className="mt-auto text-sm text-blue-600 dark:text-blue-400 underline"
                                            >
                                                Read more →
                                            </Link>

                                            {isAdmin && (
                                                <div className="flex justify-end mt-2 space-x-2">
                                                    <button
                                                        onClick={() => handleDelete(post.id)}
                                                        className="text-red-600 hover:underline text-sm"
                                                    >
                                                        Delete
                                                    </button>
                                                    <Link
                                                        to={`/admin/edit/${post.id}`}
                                                        className="text-yellow-600 hover:underline text-sm"
                                                    >
                                                        Edit
                                                    </Link>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}

                        {isAdmin && <AdminButton />}
                    </section>
                </div>
            </LayoutNoVideo>
        </>
    );
};

export default Blog;
